var render = function () {
  var _vm$user, _vm$forInitial, _vm$user2, _vm$user3, _vm$user4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nav-top border-b border-neutral-300"
  }, [_c('div', {
    staticClass: "flex justify-between py-4 px-5 bg-white"
  }, [_c('div', {
    staticClass: "w-60 flex gap-4 items-center"
  }, [_c('div', {
    staticClass: "flex items-center gap-12"
  }, [_c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleMenu();
      }
    }
  }, [_c('Hamburger')], 1)])]), !_vm.isMobile ? _c('div', {
    staticClass: "menu flex items-center gap-3"
  }, [_c('div', {
    staticClass: "relative cursor-pointer mr-5",
    on: {
      "click": function click($event) {
        return _vm.toggleNotifications();
      }
    }
  }, [_c('Bell'), _vm.unreadNotifications && _vm.unreadNotifications > 0 ? _c('span', {
    staticClass: "absolute bg-red-500 text-white font-bold rounded-full flex items-center justify-center",
    class: {
      // Posisi dan ukuran untuk angka 1-9
      'h-5 w-5 text-xs -top-2 -right-1': _vm.unreadNotifications <= 9,
      // Posisi dan ukuran untuk angka 10+
      'h-6 w-7 text-xs -top-3 -right-3': _vm.unreadNotifications > 9
    }
  }, [_vm.unreadNotifications > 10 ? [_c('span', {
    staticClass: "text-xs leading-none"
  }, [_vm._v("10")]), _c('span', {
    staticClass: "text-[0.5rem] font-extrabold leading-none relative -top-[0.2em]"
  }, [_vm._v("+")])] : [_c('span', {
    staticClass: "text-xs leading-none"
  }, [_vm._v(_vm._s(_vm.unreadNotifications))])]], 2) : _vm._e(), _vm.showNotifications ? _c('div', {
    staticClass: "absolute bg-white shadow-lg border border-gray-200 rounded-lg z-50 w-80 sm:w-96 right-0 mt-3",
    class: {
      'opacity-100 visible translate-y-0': _vm.showNotifications,
      'opacity-0 invisible translate-y-2': !_vm.showNotifications
    },
    staticStyle: {
      "transition": "opacity 0.3s ease, transform 0.3s ease, visibility 0s 0.3s"
    }
  }, [_c('div', {
    staticClass: "relative z-10 rounded bg-white text-black w-full"
  }, [_c('div', {
    staticClass: "p-3 border-b border-neutral-200 flex justify-around sticky top-0 bg-white z-20 shadow-sm"
  }, [_c('button', {
    staticClass: "text-sm px-2 pb-1 transition-colors duration-200",
    class: {
      // Perbaikan 1: Menggunakan text-teal-700
      'font-bold text-teal-700 border-b-2 border-teal-700': _vm.statusFilter === 'ALL',
      'text-neutral-500 hover:text-neutral-700': _vm.statusFilter !== 'ALL'
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.changeFilter('ALL');
      }
    }
  }, [_vm._v(" Semua ")]), _c('button', {
    staticClass: "text-sm px-2 pb-1 transition-colors duration-200",
    class: {
      // Perbaikan 1: Menggunakan text-teal-700
      'font-bold text-teal-700 border-b-2 border-teal-700': _vm.statusFilter === 'UNREAD',
      'text-neutral-500 hover:text-neutral-700': _vm.statusFilter !== 'UNREAD'
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.changeFilter('UNREAD');
      }
    }
  }, [_vm._v(" Belum Dibaca (" + _vm._s(_vm.unreadNotifications > 10 ? '10+' : _vm.unreadNotifications) + ") ")]), _c('button', {
    staticClass: "text-sm px-2 pb-1 transition-colors duration-200",
    class: {
      // Perbaikan 1: Menggunakan text-teal-700
      'font-bold text-teal-700 border-b-2 border-teal-700': _vm.statusFilter === 'READ',
      'text-neutral-500 hover:text-neutral-700': _vm.statusFilter !== 'READ'
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.changeFilter('READ');
      }
    }
  }, [_vm._v(" Sudah Dibaca ")])]), _c('div', {
    staticClass: "max-h-80 overflow-y-auto"
  }, [_vm.notifications.length === 0 ? _c('div', {
    staticClass: "text-center justify-center text-sm text-neutral-500 p-4"
  }, [_vm._v(" Notification is Empty ")]) : _c('div', [_vm._l(_vm.notifications, function (notification) {
    return _c('div', {
      key: notification.notificationId,
      staticClass: "relative p-3 border-b border-neutral-100 cursor-pointer transition-colors duration-150",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleNotificationClick(notification);
        }
      }
    }, [_c('div', {
      staticClass: "flex items-start gap-3"
    }, [_c('div', {
      staticClass: "flex-1 min-w-0"
    }, [_c('p', {
      staticClass: "text-sm font-semibold text-neutral-800 text-left line-clamp-2 pr-12",
      class: {
        'font-bold': !notification.read
      }
    }, [_vm._v(" " + _vm._s(notification.title) + " ")]), _c('p', {
      staticClass: "text-xs text-neutral-600 mt-0.5 text-left line-clamp-3"
    }, [_vm._v(_vm._s(notification.message))]), _c('p', {
      staticClass: "text-xs text-neutral-400 mt-1 text-left"
    }, [_vm._v(" " + _vm._s(_vm.formatDateNotification(notification.createdAt) || 'No date available') + " ")])])]), !notification.read ? _c('div', {
      staticClass: "absolute top-2 right-2 bg-green-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full shadow-md"
    }, [_vm._v(" Unread ")]) : _vm._e()]);
  }), _vm.hasMoreNotifications ? _c('div', {
    staticClass: "text-center p-3"
  }, [_c('button', {
    staticClass: "text-yellow-600 text-sm hover:text-yellow-700 disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": _vm.isLoadingMore
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.loadMore.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isLoadingMore ? 'Memuat...' : 'Muat Lebih Banyak') + " ")])]) : _vm._e()], 2)]), _vm.notifications.length > 0 && _vm.unreadNotifications > 0 ? _c('div', {
    staticClass: "p-3 border-t border-neutral-200 text-center sticky bottom-0 bg-white z-20"
  }, [_c('span', {
    staticClass: "inline-block text-yellow-600 text-sm cursor-pointer hover:text-yellow-700 font-medium",
    on: {
      "click": _vm.markAllAsReadAndClose
    }
  }, [_vm._v(" Tandai semua sudah dibaca ")])]) : _vm._e()])]) : _vm._e()], 1), _c('ToggleLanguage'), _vm.user.profile_image ? _c('div', {
    staticClass: "h-10 w-10 bg-cover rounded-full",
    style: "background-image: url(".concat(_vm.user.profile_image, ")")
  }) : _c('div', {
    staticClass: "h-10 w-10 bg-neutral-700 rounded-full flex justify-center items-center"
  }, [_c('p', {
    class: "font-bold text-lg text-white ".concat(((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.name) !== '' && ((_vm$forInitial = _vm.forInitial((_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2.name)) === null || _vm$forInitial === void 0 ? void 0 : _vm$forInitial.length) > 1 ? '' : 'text-xl')
  }, [_vm._v(" " + _vm._s(((_vm$user3 = _vm.user) === null || _vm$user3 === void 0 ? void 0 : _vm$user3.name) !== '' ? _vm.forInitial((_vm$user4 = _vm.user) === null || _vm$user4 === void 0 ? void 0 : _vm$user4.name) : 'A') + " ")])]), _c('div', {
    staticClass: "relative text-left pr-10 cursor-pointer user-item"
  }, [_c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('p', {
    staticClass: "text-neutral-700 text-lg font-bold leading-tight"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm.user.is_upgraded ? _c('span', {
    staticClass: "vip-badge"
  }, [_vm._v(" VIP ")]) : _vm._e()]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s(_vm.user.group))]), _c('span', {
    staticClass: "inline-block absolute top-1/2 leading-0 transform -translate-y-1/2 right-0"
  }, [_c('Chevron', {
    attrs: {
      "width": "16",
      "height": "16",
      "direction": "down",
      "color": "#101840"
    }
  })], 1), _c('div', {
    staticClass: "header__nav__menu-item-submenu invisible opacity-0 ease-linear transition-all duration-300 pt-6 left-2/4 top-full transform -translate-x-2/4 absolute cursor-default z-10"
  }, [_c('div', {
    staticClass: "user-menu bg-white shadow-xl border border-grey-darker rounded relative"
  }, [_c('div', {
    staticClass: "relative z-10 rounded bg-white p-4 text-black"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "inline-block text-yellow text-sm cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar('PROFILE');
      }
    }
  }, [_vm._v("Lihat Profil")])]), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "inline-block text-yellow text-sm cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar('PARTNER_PROFILE');
      }
    }
  }, [_vm._v("Lengkapi Profil Mitra")])]), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "inline-block text-yellow text-sm cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar('PASSWORD');
      }
    }
  }, [_vm._v("Ubah Password")])]), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "inline-block text-yellow text-sm cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar('ADDRESS');
      }
    }
  }, [_vm._v("Pengaturan Alamat")])]), _c('div', {}, [_c('span', {
    staticClass: "cursor-pointer text-yellow text-sm",
    on: {
      "click": function click($event) {
        return _vm.doLogout();
      }
    }
  }, [_vm._v("Logout")])])])])])])], 1) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }